export const getTextFieldAttributes = (value = '') => {
	const wordCount = value.split(/s+/).filter((word) => word !== '').length;
	return { queryLength: value.length, wordCount };
};
